import * as React from 'react';
const Star = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#FEB939"
      d="m3.884 14 1.083-4.683-3.633-3.15 4.8-.417L8 1.333 9.867 5.75l4.8.417-3.633 3.15L12.117 14 8 11.517 3.883 14Z"
    />
  </svg>
);
export default Star;
